export default {
  // Header Section
  "discover_your": "உங்கள்",
  "love_report": "காதல் அறிக்கை",
  "cosmic_love_insights": "அண்ட காதல் நுண்ணறிவுகள்",
  "love_report_description": "வேத ஜோதிடத்தின் அடிப்படையில் உங்கள் காதல் மற்றும் உறவு விதியைத் திறக்குங்கள். இணக்கத் தன்மை, திருமண கால நிர்ணயம், ஆன்மத் துணை பண்புகள், நீடித்த காதலுக்கான தனிப்பயன் வழிகாட்டுதல் ஆகியவற்றில் ஆழ்ந்த நுண்ணறிவுகளைப் பெறுங்கள்.",

  // Service Information
  "enter_details_for_love_analysis": "காதல் பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_love_analysis": "முழுமையான காதல் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_love_analysis_note": "உங்கள் காதல் திறன் மற்றும் உறவு இணக்கத் தன்மையின் ஆழப் பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_love_vibration": "உங்கள் பெயர் அதிர்வுகள், காதல் ஈர்ப்பு மற்றும் தொடர்பு முறைபாடுகளைப் பாதிக்கின்றன",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_love_compatibility": "உங்கள் காதல் & இணக்கம் முறைபாடுகளை நிர்ணயிக்க இது அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_love": "சுக்கிரன் மற்றும் 7ஆம் வீடு பற்றிய துல்லியக் கணக்கீடுகளுக்கு சரியான நேரம் அவசியம்",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_essential_for_love": "இடம், காதல் மற்றும் உறவுகளைப் பாதிக்கும் கிரக நிலைகளில் தாக்கம் செய்கிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் காதல் பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Love Features
  "love_compatibility_analysis": "உங்கள் காதல் வாழ்க்கை பகுப்பாய்வு",
  "relationship_potential_insights": "உறவு திறன் நுண்ணறிவுகள்",
  "marriage_timing_predictions": "திருமண கால நிர்ணய முன்கணிப்புகள்",
  "soulmate_identification": "ஆன்மத் துணை அடையாளம் காண்வு",
  "romantic_guidance_tips": "காதல் வழிகாட்டல் குறிப்புகள்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் காதல் பகுப்பாய்வில் உள்ளவை",
  "comprehensive_love_chart": "முழுமையான காதல் வரைபடம்",
  "romantic_compatibility_score": "காதல் இணக்கத் தரவரிசை",
  "relationship_guidance": "உறவு வழிகாட்டுதல்",
  "marriage_timing_insights": "திருமண கால நுண்ணறிவுகள்",

  // Actions & Buttons
  "pay_and_generate_analysis_love": "என் காதல் பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "love_analysis_processing": "உங்கள் காதல் பகுப்பாய்வை எங்கள் உறவு ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். உங்கள் காதல் விதி மற்றும் இணக்க முறைபாடுகள் குறித்து விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note_love": "உங்கள் விரிவான காதல் அறிக்கை 24 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் காதல் பகுப்பாய்வு தொகுப்பு",
  "detailed_love_report": "முழுமையான காதல் அறிக்கை (PDF)",
  "compatibility_analysis_detailed": "விரிவான இணக்கத் தன்மை பகுப்பாய்வு",
  "relationship_timing_predictions": "உறவு கால நிர்ணய முன்கணிப்புகள்",
  "soulmate_characteristics": "ஆன்மத் துணை பண்புக் குறிப்பு",
  "romantic_enhancement_tips": "காதல் மேம்பாட்டு குறிப்புகள்",

  // Visual Content
  "sample_love_analysis": "மாதிரி காதல் பகுப்பாய்வு",
  "love_compatibility_score": "உங்கள் காதல் வாழ்க்கை மதிப்பெண்",
  "sample_love_reading": "ஆழமான உணர்ச்சி இணைப்புடன் உயர்ந்த காதல் வாய்ப்பு",
  "sample_love_preview": "இணக்க நுண்ணறிவுகளுடன் உங்கள் தனிப்பயன் காதல் பகுப்பாய்வின் முன்னோட்டம்",
  "love_analysis_categories": "காதல் பகுப்பாய்வு பிரிவுகள்",

  // Love Category Types
  "compatibility": "இணக்கம்",
  "romance": "ரோமాన్స్",
  "marriage": "திருமணம்",
  "soulmate": "ஆன்மத் துணை",
  "attraction": "ஈர்ப்பு",
  "passion": "வெறுப்பு/விருப்ப தீவிரம்",

  // Status & Processing
  "your_love_analysis_status": "உங்கள் காதல் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் காதல் முறைபாடுகள் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் சுக்கிரன் நிலையும் 7ஆம் வீட்டும் ஆய்வு செய்யப்படுகின்றன; காதல் இணக்கமும் விதியும் நிர்ணயிக்கப்படுகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "காதல் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Love-Specific Elements
  "seventh_house": "7ஆம் வீடு (திருமண வீடு)",
  "venus_position": "சுக்கிரன் நிலை & தாக்கம்",
  "mars_influence": "செவ்வாய் & váத்தக் குறிகாட்டிகள்",
  "moon_emotions": "சந்திரன் & உணர்ச்சி இணக்கம்",
  "jupiter_blessings": "காதலில் வியாழனின் ஆசி",
  "love_yogas": "காதல் & திருமண யோகங்கள்",

  // Compatibility Analysis
  "zodiac_compatibility": "ராசி இணக்கம்",
  "nakshatra_matching": "நட்சத்திர இணக்கம்",
  "guna_milan": "குண மிலான் பகுப்பாய்வு",
  "doshas_matching": "தோஷ இணக்கம் சரிபார்ப்பு",
  "planetary_harmony": "கிரக ஒற்றுமை மதிப்பெண்",
  "elemental_compatibility": "மூலக்கூறு இணக்கம்",

  // Love Personality Analysis
  "romantic_nature": "காதல் இயல்பு & பாணி",
  "love_language": "உங்கள் காதல் மொழி",
  "emotional_needs": "உறவுகளில் உணர்ச்சி தேவைகள்",
  "attraction_patterns": "ஈர்ப்பு முறைபாடுகள்",
  "relationship_approach": "உறவு அணுகுமுறை பாணி",
  "commitment_style": "உறுதி & நம்பிக்கை பாணி",

  // Soulmate Analysis
  "soulmate_characteristics": "ஆன்மத் துணை பண்புகள்",
  "ideal_partner_traits": "இயலான துணை பண்புகள்",
  "soulmate_timing": "ஆன்மத் துணையை எப்போது சந்திப்பீர்",
  "recognition_signs": "ஆன்மத் துணை அடையாளக் குறிகள்",
  "karmic_connections": "கர்ம காதல் இணைப்புகள்",
  "twin_flame_indicators": "ட்வின் ஃப்ளேம் குறிகாட்டிகள்",

  // Marriage Predictions
  "marriage_timing": "திருமண கால நிர்ணய முன்கணிப்புகள்",
  "wedding_auspicious_dates": "சுப திருமண தேதிகள்",
  "married_life_forecast": "திருமண வாழ்க்கை முன்னறிவிப்பு",
  "spouse_characteristics": "துணைவர் பண்புகள்",
  "marriage_compatibility": "திருமண இணக்கத் தரவரிசை",
  "family_harmony": "குடும்ப ஒற்றுமை வாய்ப்புகள்",

  // Relationship Phases
  "dating_guidance": "டேட்டிங் கட்ட வழிகாட்டுதல்",
  "courtship_period": "முன் திருமணச் சந்திப்பு கட்ட நுண்ணறிவுகள்",
  "engagement_timing": "நிச்சயதார்த்த நேர நிர்ணயம்",
  "pre_marriage_guidance": "திருமணத்திற்கு முன் வழிகாட்டுதல்",
  "honeymoon_phase": "ஹனிமூன் கட்ட முன்கணிப்புகள்",
  "long_term_relationship": "நீண்டகால உறவுக் கணிப்பு",

  // Love Challenges & Solutions
  "relationship_challenges": "சாத்தியமான உறவு சவால்கள்",
  "compatibility_issues": "முகங்கொடுக்க வேண்டிய இணக்கப் பிரச்சினைகள்",
  "communication_style": "தொடர்பாடல் பாணி பொருத்தம்",
  "conflict_resolution": "மோதல் தீர்க்கும் வழிகாட்டுதல்",
  "trust_building": "நம்பிக்கை உருவாக்கும் உத்திகள்",
  "intimacy_enhancement": "நெருக்கத்தை மேம்படுத்தும் குறிப்புகள்",

  // Romantic Timing
  "love_favorable_periods": "காதலுக்கு சாதகமான காலங்கள்",
  "romantic_peak_times": "காதல் உச்ச நேரங்கள்",
  "proposal_timing": "முன்மொழிவுக்கான சிறந்த நேரம்",
  "relationship_milestones": "உறவு மைல்கல் நேர நிர்ணயம்",
  "anniversary_significance": "திருமண நாள் முக்கியத்துவம்",
  "renewal_periods": "உறவு புதுப்பிக்கும் காலங்கள்",

  // Venus Analysis
  "venus_sign_influence": "சுக்கிர ராசி தாக்கம்",
  "venus_house_position": "சுக்கிரன் வீட்டு நிலை",
  "venus_aspects": "சுக்கிரன் தன்வழி/பார்வை",
  "venus_dignity": "சுக்கிரன் பலம் & கௌரவம்",
  "venus_remedies": "சுக்கிரன் பரிகாரங்கள்",
  "venus_mantras": "சுக்கிரன் காதல் மந்திரங்கள்",

  // Love Types & Styles
  "passionate_love": "தீவிர காதல் குறிகாட்டிகள்",
  "companionate_love": "நட்பு சார்ந்த காதல் பாணி",
  "romantic_love": "ரோமாண்டிக் காதல் வெளிப்பாடு",
  "unconditional_love": "நிபந்தனையற்ற காதல் திறன்",
  "spiritual_love": "ஆன்மீக காதல் இணைப்பு",
  "platonic_relationships": "பிளாடானிக் உறவு நுண்ணறிவுகள்",

  // Compatibility Factors
  "mental_compatibility": "மன இணக்கம்",
  "emotional_compatibility": "உணர்ச்சி இணக்கம்",
  "physical_compatibility": "உடல் இணக்கம்",
  "spiritual_compatibility": "ஆன்மீக இணக்கம்",
  "lifestyle_compatibility": "வாழ்க்கைமுறை இணக்கம்",
  "financial_compatibility": "திருமணத்தில் நிதி இணக்கம்",

  // Love Remedies
  "love_enhancing_remedies": "காதல் மேம்பாட்டு பரிகாரங்கள்",
  "relationship_healing": "உறவு குணப்படுத்தும் முறைகள்",
  "attraction_remedies": "ஈர்ப்பு மேம்பாட்டு பரிகாரங்கள்",
  "marriage_delay_remedies": "திருமண தாமதம் குறைக்கும் பரிகாரங்கள்",
  "love_gemstones": "காதல் & உறவு ரத்தினங்கள்",
  "romantic_rituals": "காதல் சார்ந்த நிகழ்வுகள் & முறைகள்",

  // Past Life & Karma
  "past_life_love_connections": "முன் பிறவி காதல் இணைப்புகள்",
  "karmic_relationships": "கர்ம உறவு முறைபாடுகள்",
  "soul_contracts": "காதலில் ஆத்தும ஒப்பந்தங்கள்",
  "karmic_debt_love": "உறவுகளில் கர்ம கடன்",
  "spiritual_lessons_love": "காதல் மூலம் ஆன்மீகப் பாடங்கள்",
  "past_life_spouse": "முன் பிறவி துணை இணைப்புகள்",

  // Love Forecast
  "monthly_love_forecast": "மாதாந்திர காதல் முன்னறிவிப்பு",
  "yearly_romance_predictions": "ஆண்டு ரோமாந்ஸ் முன்கணிப்புகள்",
  "love_life_phases": "காதல் வாழ்க்கை கட்டங்கள்",
  "relationship_cycles": "உறவு சுழற்சிகள்",
  "romantic_opportunities": "முன்னிலையில் காதல் வாய்ப்புகள்",
  "love_life_transformation": "காதல் வாழ்க்கை மாற்றக் காலங்கள்",

  // Special Love Scenarios
  "second_marriage": "இரண்டாம் திருமண வாய்ப்புகள்",
  "late_marriage": "தாமதமான திருமணம் முன்கணிப்புகள்",
  "love_marriage_vs_arranged": "காதல் திருமணம் vs ஏற்பாடு திருமணம்",
  "intercaste_marriage": "சாதி தாண்டிய திருமண வாய்ப்புகள்",
  "foreign_spouse": "வெளிநாட்டு துணை வாய்ப்புகள்",
  "celebrity_romance": "உயர் புகழ் காதல் குறிகாட்டிகள்",

  // Relationship Counseling
  "pre_marital_counseling": "திருமணத்திற்கு முன் ஜோதிட ஆலோசனை",
  "relationship_therapy": "ஜோதிட உறவு தெரபி",
  "couple_compatibility": "ஜோடி இணக்கம் மேம்பாடு",
  "marriage_counseling": "திருமண ஆலோசனை நுண்ணறிவுகள்",
  "relationship_revival": "உறவு மீளுருவாக்க வழிகாட்டுதல்",
  "love_life_coaching": "காதல் வாழ்க்கை பயிற்சி",

  // Advanced Love Analysis
  "composite_chart_analysis": "காம்பசிட் சார்ட் பகுப்பாய்வு",
  "synastry_compatibility": "சைனஸ்ட்ரி இணக்கம் வாசிப்பு",
  "davison_relationship_chart": "டேவிசன் உறவு சார்ட்",
  "progressed_love_indicators": "ப்ரோக்ரெஸ்டு காதல் குறிகாட்டிகள்",
  "solar_return_love": "சூரிய ரிட்டர்ன் காதல் கணிப்புகள்",
  "lunar_return_romance": "சந்திர ரிட்டர்ன் ரோமாந்ஸ் நுண்ணறிவுகள்"
};
